import React, { useMemo } from 'react';
import { orderBy, sum } from 'lodash';

import BarChart from '../../../charts/BarChart';

const HospitalsSetsBarChart = ({ sets = [], hospitals = [], minDate, maxDate }) => {
  const data = useMemo(() => {
    const filteredSets = sets?.filter((set) => minDate.isBefore(set.date) && maxDate.isAfter(set.date));
    const allHospitals = hospitals
      .map((hospital) => {
        const hospitalSets = filteredSets.filter((item) => item.hospital === hospital.id);
        return {
          id: hospital.name,
          label: `${hospital?.name?.substring(0, 10)}${hospital?.name?.length > 10 ? '...' : ''}`,
          value: sum(hospitalSets?.map((set) => set.quantity)),
          // value: hospitalSets.length,
        };
      })
      .filter((hospital) => hospital.value !== 0);

    const sortedHospitals = orderBy(allHospitals, 'value', 'desc');
    const top10 = sortedHospitals.splice(0, 10);

    return top10;
  }, [sets, hospitals, minDate, maxDate]);

  return (
    <div className="management-reports-chart__container m-l-md" style={{ width: '50%' }}>
      <div className="font-size-bg font-bold">Top Hospitals</div>
      <div className="secondary m-t-sm m-b-lg">Shipped sets by top 10 hospitals</div>
      <BarChart
        data={data || []}
        entity="set"
        height="300px"
        layout="horizontal"
        indexBy="id"
        enableLabel={true}
        margin={{ top: 10, right: 30, bottom: 30, left: 90 }}
        axisLeft={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          truncateTickAt: 0,
          format: name => `${name?.substring(0, 10)}${name?.length > 10 ? '...' : ''}`,
        }}
        labelTextColor={{
          from: 'color',
          modifiers: [
            [
              'darker',
              1.6,
            ],
          ],
        }}
      />
    </div>
  );
};

export default HospitalsSetsBarChart;
